/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable arrow-body-style */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
    BehaviorSubject,
    catchError,
    map,
    Observable,
    of,
    ReplaySubject,
    switchMap,
    take,
    tap,
    throwError,
} from 'rxjs';
import { environment } from 'src/environments/environment';
import { Raza } from './raza.types';

@Injectable({
    providedIn: 'root',
})
export class RazaService {
    private urlApiAuth: string = environment.BASE_URL;
    private _Raza: BehaviorSubject<Raza> = new BehaviorSubject<Raza>(null);
    private _Razas: BehaviorSubject<Raza[] > = new BehaviorSubject<Raza[]>(null);

    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient) {}

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    //////////////////////////////////////////////////////////////////////////////////////////////////

    /**
     * Getter for Raza
     */
    get Raza$(): Observable<Raza> {
        return this._Raza.asObservable();
    }

    /**
     * Getter for Razas
     */
    get Razas$(): Observable<Raza[]> {
        return this._Razas.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------
    /**
     * Get Raza by id
     */

    getRazas(): Observable<Raza[]>
    {
        // Si ya tenemos datos en el BehaviorSubject, retornarlos sin hacer nueva petición
        const currentRazas = this._Razas.getValue();
        if (currentRazas && currentRazas.length > 0) {
            return of(currentRazas);
        }

        // Si no tenemos datos, hacer la petición HTTP
        return this._httpClient.get<Raza[]>(this.urlApiAuth + 'citas/reactive/raza').pipe(
            switchMap((Razas: Raza[]) =>
            {
                this._Razas.next(Razas);
                return of(Razas);
            }),
            catchError((error: any) => {
              return of([]);
            }));
    }

    getRazaById(id: string): Observable<Raza> {
        return this._httpClient.get<Raza>(this.urlApiAuth + '/' + id).pipe(
            take(1),
            switchMap((Raza: Raza) => {
                if (!Raza) {
                    return throwError(
                        'Could not found Raza with id of ' + id + '!'
                    );
                }
                this._Raza.next(Raza);
                this.updateRazaInList(Raza);
                return of(Raza);
            })
        );
    }

    updateRaza(Raza: Raza): Observable<Raza> {
        return this._httpClient.put<Raza>(this.urlApiAuth + '/', Raza).pipe(
            take(1),
            switchMap((Raza: Raza) => {
                this._Raza.next(Raza);
                this.updateRazaInList(Raza);
                return of(Raza);
            })
        );
    }
    deleteRaza(id: string): Observable<boolean> {
        return this._httpClient.delete<any>(this.urlApiAuth + id).pipe(
            take(1),
            switchMap((data: any) => {
                this.updateRazaInList(this.getRazaByIdInList(+id));
                return of(data);
            })
        );
    }
    /**
     * Create Raza
     */
    createRaza(Raza: Raza): Observable<Raza> {
        return this._httpClient.post<Raza>(this.urlApiAuth, Raza).pipe(
            take(1),
            switchMap((Raza: Raza) => {
                this._Razas.next([Raza, ...this._Razas.value]);
                return of(Raza);
            })
        );
    }

    /*
     *
     *Funciones auxiliares
     */

    // Función para actualizar un objeto Raza en la lista
    updateRazaInList(updatedRaza: Raza): void {
        const currentRazas = this._Razas.getValue();

        if (currentRazas) {
          const indice = currentRazas.findIndex(group => group.id === updatedRaza.id);
          if (indice !== -1) {
            currentRazas[indice] = updatedRaza;
              this._Razas.next([...currentRazas]); // Emite una nueva lista actualizada
          } else {
              console.log(`No se encontró ningún Raza con el ID ${updatedRaza.id}.`);
          }
      } else {
          console.log('La lista de grupos está vacía.');
      }
    }

    getRazaByIdInList(id: number): Raza | null{
        const currentRazas = this._Razas.value;

        if (currentRazas) {
            this._Razas.value.map((Raza: Raza) => {
                if (Raza.id === id) {
                    return Raza;
                }
            });

            return null;
        }
    }

    /**
     * Limpiar caché de razas - útil cuando se necesite refrescar los datos
     */
    clearRazasCache(): void {
        this._Razas.next(null);
    }

    /**
     * Forzar recarga de razas desde el servidor
     */
    refreshRazas(): Observable<Raza[]> {
        this.clearRazasCache();
        return this.getRazas();
    }
}
